import { useTranslate } from '@c3po/i18n'
import Button from '@kawaui/button'

import Layout from 'components/FlatLayout'
import FloatNav from 'components/FloatNav'
import PageProviders from 'components/page-providers'
import Separator from 'components/separator'
import { Device } from 'constants/index'
import { Container, Box, Title, Description } from 'styles/pages/404'
import { goMyAccount } from 'utils/methods'
import useDevice from 'utils/useDevice'

const CustomErrorBase = () => {
  const { i18n } = useTranslate()
  const device = useDevice()
  return (
    <Layout hasFooter>
      {device === Device.MOBILE && <FloatNav />}
      <Container>
        <Box>
          <Title>{i18n('errors.page_not_found.modal.title')}</Title>
          <Description>{i18n('errors.page_not_found.modal.text')}</Description>

          <Separator height="sm" />
          <Button isFullWidth onClick={goMyAccount}>
            {i18n('errors.page_not_found.modal.account.cta')}
          </Button>
        </Box>
      </Container>
    </Layout>
  )
}

const CustomError = () => (
  <PageProviders>
    <CustomErrorBase />
  </PageProviders>
)

export default CustomError
